import { render, staticRenderFns } from "./termsAndCondition.vue?vue&type=template&id=19972d3c&scoped=true&"
import script from "./termsAndCondition.vue?vue&type=script&lang=js&"
export * from "./termsAndCondition.vue?vue&type=script&lang=js&"
import style0 from "./termsAndCondition.vue?vue&type=style&index=0&id=19972d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19972d3c",
  null
  
)

export default component.exports